module.exports = __webpack_public_path__ + "img/jcb.c783ded1.svg";